import CostItem from "../../../utils/services/project/accounting/costItemService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
let crud = crudTemplate(CostItem);
let roles = rolesTemplate(CostItem);

function prepareItem(i) {
  i._cost_centre = i._cost_centre || { id: null };
  i._billing_period = i._billing_period || { id: null };
  i.cost_centre_id = i._cost_centre && i._cost_centre.id;
  i.cost_centre_name = i._cost_centre && i._cost_centre.name;
  i.billing_period_id = i._billing_period && i._billing_period.id;
  i.billing_period_name = i._billing_period && i._billing_period.name;
  return i;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  ...roles.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item.amount = item.amount
      .toString()
      .trim()
      .replace(",", ".");
    item._cost_centre = { id: item.cost_centre_id };
    item._billing_period = { id: item.billing_period_id };
    return crud.actions.create(_, {
      item,
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item.amount = item.amount
      .toString()
      .trim()
      .replace(",", ".");
    return crud.actions.update(_, {
      item,
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
